import React from "react";
import { string, func } from "prop-types";

import { Search } from "../icons/search";

import "./search-bar.m.css";

const SearchBar = ({ placeholder, onChange, value }) => {
  return (
    <form styleName="container">
      <input styleName="search-input" placeholder={placeholder} onChange={onChange} value={value} />
      <Search color={"#000"} />
    </form>
  );
};

export default SearchBar;

SearchBar.propTypes = {
  placeholder: string,
  onChange: func,
  value: string
};
